export default function PHP_highlight_file() {
  return (
    <div>
      <h1>PHP_highlight_file</h1>
    </div>
  );
}
